import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { Field } from "../../models/field";
import { Role } from "../../models/role";
import {AuthService} from "../auth/auth-service";
import Helpers from "../../utils/helpers";

@Injectable()
export class RoleControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient, private authService: AuthService) {
  }

  public getRolesList(serviceId: string, reusable: boolean): Observable<Role[]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/role?reusable=" + reusable) as Observable<Role[]>;
  }

  public getRolesDetailedList(serviceId: string): Observable<Role[]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/role?includeDetails=true") as Observable<Role[]>;
  }

  public getFrontendBots(serviceId: string): Observable<Role[]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/role?onlyFrontendBots=true") as Observable<Role[]>;
  }

  public getRole(roleId: string): Observable<Role> {
    return this.http.get(this.baseUrl + "role/" + roleId) as Observable<Role>;
  }

  public saveUserRole(role: Role) {
    Helpers.trimRecursiveObj(role);
    const body = JSON.stringify(role);
    return this.http.put(this.baseUrl + "role", body, { responseType: "text" });
  }

  public saveBotRole(role: Role) {
    Helpers.trimRecursiveObj(role);
    const body = JSON.stringify(role);
    return this.http.put(this.baseUrl + "bot_role", body, { responseType: "text" });
  }

  public createUserRole(serviceId: string, role: Role) {
    Helpers.trimRecursiveObj(role);
    const body = JSON.stringify(role);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/role", body);
  }

  public createBotRole(serviceId: string, role: Role) {
    Helpers.trimRecursiveObj(role);
    const body = JSON.stringify(role);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/bot_role", body);
  }

  public deleteRole(roleId: string) {
    return this.http.delete(this.baseUrl + "role/" + roleId, { responseType: "text" });
  }

  public generateDefaultApplicantForm(serviceId: string, fields: Field[]) {
    Helpers.trimRecursiveObj(fields);
    const body = JSON.stringify(fields);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/applicant-form/generate", body);
  }

  public getFormPreviewUrl(roleId: string): Observable<any> {
    return this.http.get(this.baseUrl + "role/generate-form-preview/" + roleId, {responseType: "text"}) as Observable<any>;
  }

  public async getDSPreviewUrl(serviceId: string, roleId: string) {
    const tokenJWT = await this.authService.getToken();
    return environment.E_REGISTRATIONS_URL + "redirect-to-service/" + serviceId + "?tokenJWT=" + tokenJWT + "&role_name=" + roleId;
  }

  public getHistoryPage(roleId: string, page: number): Observable<any[]> {
    return this.http.get(this.baseUrl + "role/" + roleId + "/pagedhistory?pageNo=" + page + "&pageSize=12") as Observable<any[]>;
  }

  // Get form schema for preview only (GET request)
  public getFormSchemaForRevision(roleId: string, revisionNumber: string): Observable<any> {
    return this.http.get(this.baseUrl + "role/" + roleId + "/history/" + revisionNumber + "/schema") as Observable<any>;
  }

  // Revert form to a specific revision (PUT request - triggers cleanup of orphaned relations)
  public revertFormToRevision(roleId: string, revisionNumber: string): Observable<any> {
    return this.http.put(this.baseUrl + "role/" + roleId + "/history/" + revisionNumber, null, {responseType: "text"}) as Observable<any>;
  }

}
